import React from "react"
import Loading from "@irati/ui/src/Loading"
import {useBudgetsPermissions, useBudgetsList} from "@irati/wallet/hooks/budget"
import {useFlexiPointsMigrationRedirect} from "@irati/wallet/hooks/flexiMigrationRedirect"
import Container from "../styled/Container"
import Heading from "./Heading"
import Dashboard from "./Dashboard"
import {BudgetManagementProvider, useBudgetManagement} from "./hooks"
import EditDashboard from "./EditDashboard"
import {BudgetModalsProvider} from "./Modals"

export default function BudgetDashboardContainer() {
  useFlexiPointsMigrationRedirect()
  return (
    <BudgetManagementProvider>
      <BudgetDashboard />
    </BudgetManagementProvider>
  )
}

function BudgetDashboard() {
  const {state} = useBudgetManagement()
  const {canBudget} = useBudgetsPermissions()
  const {load, data: budgets} = useBudgetsList()

  if (!canBudget) return null

  return (
    <Container>
      <BudgetModalsProvider>
        <Heading />
        {!budgets && <Loading load={load} />}
        {!state?.editing && <Dashboard />}
        {state.editing && <EditDashboard />}
      </BudgetModalsProvider>
    </Container>
  )
}
